import { take } from 'rxjs';
import { PlanEntity } from 'src/app/plan/domain/entities/plan.entity';
import { PlanPort } from 'src/app/plan/domain/ports/plan.port';
import { UseCase } from '../../base/use-case';

export class GetPlanUseCase implements UseCase<void, void> {
  private LEAL_PLAN_ALERTS: string = 'lealPlanAlerts';

  constructor(private planPort: PlanPort) {}

  execute(): void {
    this.planPort
      .getPlan()
      .pipe(take(1))
      .subscribe((plan: PlanEntity) => {
        localStorage.setItem(this.LEAL_PLAN_ALERTS, JSON.stringify(plan));
        setTimeout(() => {
          const event = new CustomEvent('lealPlanAlertsEvent');
          window.dispatchEvent(event);
        }, 100);
      });
  }
}
